import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from '@angular/router';
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, EventEmitter, HostListener, Input, Output, ViewChild,Renderer2, Injector } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import { BroadcastManager } from "../../../../_appCommon/base/BroadcastManager";
import { UrlQueryDef } from "src/app-client/_appCommon/base/UrlQueryDef";
import { CaseStageDataService } from '../../../../_dataservices/CaseStageDataService';
import { AppEventNames } from 'src/app-client/_appCommon/base/Constants';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ICaseStage, Status, StatusesID } from "src/app-client/_appCommon/base/AppInterfaceAndBaseClasses";
import { CRUDFormControllerBase } from "src/app-client/_appCommon/base/CRUDFormControllerBase";
import { StatusDataService } from "src/app-client/_dataservices/StatusDataService";
import { StatusManagerService } from "src/app-client/_dataservices/StatusManagerService";
import { CaseDataService } from "src/app-client/_dataservices/CaseDataService";
import { AppClientContext } from 'src/app-client/_appCommon/base/AppClientContext';
import { SetupDataService } from "src/app-client/_dataservices/SetupDataService";
import { CustomerAddressDataService } from "src/app-client/_dataservices/CustomerAddressDataService";
import { AddressExceptionsDataService } from "src/app-client/_dataservices/AddressExceptionDataService";
import { CustomerDataService } from "src/app-client/_dataservices/CustomerDataService";
import { SystemServicesDataService } from "src/app-client/_dataservices/security/SystemServicesDataService";
import { ECOMMERCE_USER_TOKEN } from 'src/app/_appCommon/base/Constants';
import { MatRadioChange } from "@angular/material/radio";
import { DatePipe } from "@angular/common";
import { SystemConfigDataService } from "src/app-client/_dataservices/SystemConfigDataService";
import { SmartSTLRequestStatuses } from "src/app/_appCommon/base/AppInterfaceAndBaseClasses";

@Component({
  selector: 'app-client-case-stages',
  templateUrl: './case-stages.component.html',
  styleUrls: ['./case-stages.component.css'],
  providers: [CaseStageDataService, StatusDataService,SetupDataService,CustomerAddressDataService,AddressExceptionsDataService,CustomerDataService,SystemServicesDataService,SystemConfigDataService]
})
export class CaseStagesComponent extends CRUDFormControllerBase<CaseStageDataService>
{
  @Input() public caseId: number = 0;
  @Input() public availableAligners: number = 0;
  @Input() public isCaseExpired: boolean;
  @Input() public isFinalStatus: boolean = false;
  @Input() public currentStageNumber: number = 0;
  @Output() public stagesSelected = new EventEmitter<any[]>();
  @ViewChild('chooseSetupTypeDialog') protected chooseSetupTypeDialog: any;
  @ViewChild('approvalDialog') protected approvalDialog: any;
  @ViewChild('deleteDialog') protected deleteDialog: any;
  @ViewChild('deleteStageDialog') protected deleteStageDialog: any;
  @ViewChild('showShippingInfoDialog') protected showShippingInfoDialog: any;
  @ViewChild('alignersForm') public alignersForm: NgForm;
  @ViewChild('suggestAlignersByAliwellDialog') protected suggestAlignersByAliwellDialog: any;
  @ViewChild('commentsAlignersByAliwellForm') public commentsAlignersByAliwellForm: NgForm;
  @ViewChild('updateCaseStageAddressDialog') protected updateCaseStageAddressDialog: any;
   

  public isShowApprovalMessage: boolean = false;
  public stageToApprove: any;
  public statusList: any;
  @Input() public case:any;
  public displayedColumns: string[] = ['select', 'stageNumber', 'upperAligners', 'lowerAligners', 'frecuencyDays', 'startDate', 'totalAlignersQuantity', 'statusDescriptionEcommerce', 'actions'];

  public dataSource: MatTableDataSource<any>;
  public currentNewStageId: any;
  public currentStages = [];
  public caseStageSelected: any;
  public remainingAligners:number=0;
  public remainingCaseUpperAligners:number=0;
  public remainingCaseLowerAligners: number = 0;
  public fabricatedUpperAligners: number = 0;
  public fabricatedLowerAligners: number = 0;
  public currentUpperAligners: number = 0;
  public currentLowerAligners: number = 0;
  public currentFrequency: number = 0;
  public currentStartDate: number = 0;
  public disableAcceptSetup:boolean=false;
  public hasSetupMechanics:boolean=false;

  public disableEditAligners:boolean=false;
  public lastStage:boolean=false;
  public isSetupCompleted: boolean = false;
  public newSetupId: number = 0;
  public size930 = false;
  public newCaseStage: any;
  public isPartialSave: boolean = false;
  public lastCreatedStage: any;
  public Statuses:any = StatusesID;
  public orderStatusToValidateAligners: number = 9;
  public formStep9Valid: boolean = false;
  public setupOptions =
    [
      {
        label: 'Nueva Etapa',
        description: "Será necesario subir archivos actualizados para crear una nueva etapa (STL's y fotografías).",
        value: 1,
      },
      {
        label: 'Reimpresión',
        description: 'Para reimprimir uno o varios alineadores de la última etapa previamente enviada.',
        value: 2,
      }
    ];
  
  public setupCorrectionsOptions: any[] = [
    { value: 1, name: 'samePlanCorrection', label: 'Correción sobre el mismo plan', description: "Favor de indicar detalles que te gustaría modificar de este plan" },
    { value: 2, name: 'treatementChanges', label: 'Cambios de plan de tratamiento', description: "Favor de escribir con detalle el plan de tratamiento nuevo que deseas" },
    { value: 3, name: 'requestLessQuantity', label: 'Solicitar menos alineadores totales', description: "Indicar los movimientos que deseas limitar o eliminar para reducir el número de alineadores" }
  ];

  public correctionValues: string[] = Array(this.setupCorrectionsOptions.length).fill('');


  public setupType = 0;

  public loading = false;

  private unsubscribe: Subject<void> = new Subject();

  public protocolForUseAlignersData: any;

  public createdNewStage:boolean =false;
  public generalComments: string | null;
  public importantChangesComments: string | null;
  public preSetupUsed: boolean = false;

  public inShippingAddressSelectionProcess: boolean = false;
  public shippingAddressSelectionProcess: number = 1;
  public customerAddresses: any;
  public exceptionAddresses: any;
  public addressList: any;
  public previousAddress: any;
  public defaultAddress: any;
  public selectedAddress: any;
  public isApproveWithChanges: boolean = false;
  public updateAlignersValidationsPassed: boolean = true;
  public alignersFormValue: any;
  public customerId: number;
  public caseStageAddressToUpdate: any;
  public maxHoursToUpdateDate: number = 0;
  public isApproveChecked: boolean = false;
  public selectedSetupCorrection: number = 1;

  public isPrescriptionCompleted: boolean = false;
  public isCaseFileCompleted : boolean = false;
  public setupValidationsDone : boolean = false;
  constructor(
    activatedRoute: ActivatedRoute,
    caseStageDataService: CaseStageDataService,
    public statusManagerService: StatusManagerService,
    private statusDataService : StatusDataService,
    private caseDataService: CaseDataService,
    private setupDataService: SetupDataService,
    private customerAddressDataService: CustomerAddressDataService,
    private addressExceptionsDataService:AddressExceptionsDataService,
    private customerDataService: CustomerDataService,
    private systemServicesDataService: SystemServicesDataService,
    private systemConfigDataService: SystemConfigDataService,
    private renderer: Renderer2,
    private injector: Injector,
    private router:Router
  )
  {
    super(activatedRoute, caseStageDataService);
    this.getStatusHasRequiresSufficientAlignersAvailableFlagActivated();
  }

  ngOnInit(): void
  {
    this.getRemainingAligners(false);
    this.checkResolution();
    this.getAllCaseStages();
    this.getAllStatus();
    if (AppClientContext.Instance.customerId)
      this.customerId = AppClientContext.Instance.customerId;
    else
      this.getStartupInfo();

    this.getCustomerInfo();
    // Observables
    BroadcastManager.Instance.on(AppEventNames.OnCheckOrderToManufacture)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        if(e[0])
        {
          this.sendOrderToManufactureStages();
        }
      });

    BroadcastManager.Instance.on(AppEventNames.onCompleteSetup)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        if(e[0])
        {
          this.isSetupCompleted = true;
          this.newSetupId = e[0];
          BroadcastManager.Instance.broadcast(AppEventNames.onUpdatePrescriptionFiles, true);
        }
      });

      BroadcastManager.Instance.on("on-create-new-case-stage")
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        if(e[0])
        {
          this.newSetupId = e[0];
          this.onCreateStage(this.newSetupId);
        }
      });

      BroadcastManager.Instance.on(AppEventNames.onUpdateProtocolForUseAligners)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(([data]: any) =>
        {
          this.protocolForUseAlignersData = data[0];

          if(data && this.createdNewStage)
          {
            data[0].caseId = this.caseId;
            this.protocolForUseAlignersData = data[0];
            this.updateSetupProtocolForUseAligners();
          }
        });

      BroadcastManager.Instance.on("step9Valid")
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([data]: any) =>
      {
        this.formStep9Valid = data[0];
        if(!data[0]){
          this.isSetupCompleted = data[0];
        }
      });

      BroadcastManager.Instance.on(AppEventNames.onPrescriptionStepsSaved)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([data]: any) =>
      {
        this.getSetupInfoToValidate();
        this.isPrescriptionCompleted = true;

      });    
        
  }

  private getStartupInfo()
  {
    this.systemServicesDataService.getStartupInfo()
      .subscribe((startupInfo) =>
      {
        this.onApplicationStartup(startupInfo);
      }, error =>
      {
        if (error.status == 401)
        {
          this.forceLogout();
        }
      });
  }

  private onApplicationStartup(startupInfo: any)
  {
    AppClientContext.Instance.initialize(startupInfo);

    // Save a reference to the angular injector to the client context
    AppClientContext.Instance.setInjector(this.injector);

    this.getCustomerInfo();
  }

  private getCustomerInfo() : void
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((response: any) =>
        {
          let currentUser = response.items.firstOrNull();
          if (currentUser)
          {
            AppClientContext.Instance.customerId = currentUser.id;
            this.customerId = currentUser.id;
            this.getAddresses();
          }
        });
    }
  }

  public forceLogout(): void
  {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');

    // Remove Token
    AppClientContext.Instance.headerValues.delete(ECOMMERCE_USER_TOKEN);

    // Clear current user
    AppClientContext.Instance.user = null;
  }

  getStatusHasRequiresSufficientAlignersAvailableFlagActivated(){
    let queryDef = new UrlQueryDef();
    queryDef.addParam("requiresSufficientAlignersAvailable", true);
    this.statusDataService.getStatusesByFlag(queryDef).subscribe(res=>{
      this.orderStatusToValidateAligners = res[0].order;
    }, err=>{
      this.setWarningAlert('No existe status para calcular etapas fabricadas, revise la configuración de estatus, e intente de nuevo.');
    })
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public sendOrderToManufactureStages(): void
  {
    let stageNumbers = this.caseStagesSelected.map(x => x.stageNumber);

    if(stageNumbers)
    {
      this.dataService.updateListCaseStageManufactured(stageNumbers, this.caseId)
        .subscribe(response =>
        {
          if(response)
          {
            this.getAllCaseStages();
          }
        });
    }
  }

  private getAllCaseStages(): void
  {
    if(this.caseId)
    {
      this.dataService.get(this.onGetQueryDefForGetAll())
        .subscribe((response: any) =>
        {
          this.currentStages = response?.rows != null ? response?.rows : [];
          this.dataService.getLastCaseStageCreated(this.onGetQueryDefForGetLastCaseStageCreated())
          .subscribe((res)=>{
            this.lastCreatedStage = res;
            this.currentStages = this.currentStages.filter(x=> x.isDeleted == false || (x.id == res.id && x.statusId == StatusesID.StageCancelled));
            this.setDataSourceStages();
          });

        });
    }
  }

  private setDataSourceStages(): void
  {
    if (this.currentStages)
    {
      this.resetCaseStages();
      this.dataSource = new MatTableDataSource<any>(this.currentStages);
    }
  }

  private resetCaseStages(): void
  {
    this.currentStages.forEach(element =>
    {
      element.editMode = false;
      element.checked = false;
    });

    this.stagesSelected.emit(this.caseStagesSelected);
  }

  public dropTable(event: CdkDragDrop<any[]>)
  {
    let previousData = event.previousContainer.data['data'];
    let previousStageData = previousData[event.currentIndex];
    if (previousStageData.orderStatus >= this.orderStatusToValidateAligners)
    {
      this.setInfoAlert("No es posible mover etapas en proceso de fabricación.");
      return;
    }
    else if (previousStageData.stageNumber == 1)
    {
      this.setInfoAlert("No es posible mover la etapa inicial del caso.");
      return;
    }

    const prevIndex = this.currentStages.findIndex(d => d === event.item.data);
    this.reorderImages(prevIndex, event.currentIndex);
  }

  private reorderImages(prevIndex: number, currentIndex: number)
  {
    moveItemInArray(this.currentStages, prevIndex, currentIndex);
    this.updateCaseStageListOrder();
  }

  private updateCaseStageListOrder (): void
  {
    let i = 1;
    this.currentStages.forEach(x => { x.stageNumber = i; i++; });
    this.dataService.updateListCaseStageOrder(this.currentStages)
      .subscribe(response =>
      {
        this.getAllCaseStages();
        this.setSuccessAlert("Se ha actualizado el orden de las etapas correctamente");
        BroadcastManager.Instance.broadcast(AppEventNames.onUpdatePrescriptionFiles, true);
      }, fail =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  public setStageDates(event: any, item: any): void
  {
    let startDate = new Date(event.value.toString()), endDate = new Date();
    startDate.setHours(12, 0, 0, 0);

    this.currentStages.find(x => x == item).startDate = startDate;

    // Calculate end date
    endDate.setDate(startDate.getDate() + item.frecuencyDays);
    this.currentStages.find(x => x == item).endDate = endDate;
  }

  public onSelectSetupType(): void
  {
    if (this.setupType == 2) // Previous Setup
    {
      if (this.generalComments != null && this.generalComments != "") {
        this.preSetupUsed = true;
        this.isPrescriptionCompleted = true;
        this.isCaseFileCompleted = true;
        this.isPartialSave = false;
        this.onCreateStage();
      }
      else {
        this.setInfoAlert("Ingresa comentarios para continuar.")
      }

    }
    else 
    {
      this.getSetupInfoToValidate();
      let queryDef = new UrlQueryDef;
      queryDef.includes = "DentalMonitoringSmartStl,CaseFile";
      this.setupDataService.getById(AppClientContext.Instance.setup.id, queryDef)
        .subscribe((res: any) => 
        {
          if (res.usesSmartStl == true && res.dentalMonitoringSmartStlId != null && res.dentalMonitoringSmartStl?.status == SmartSTLRequestStatuses.get("Smart STL disponible")
            && res.caseFileId != null && res.caseFile.upperSTLId != null && res.caseFile.lowerSTLId != null) {
            this.isCaseFileCompleted = true;
          } else if (res.usesSmartStl == false && res.caseFileId != null && res.caseFile.lowerSTLId != null && res.caseFile.upperSTLId != null) {
            this.isCaseFileCompleted = true;
          } else {
            this.isCaseFileCompleted = false;
          }
          // New Setup
          if (this.setupType == 1 && this.isSetupCompleted) 
          {
            if (this.formStep9Valid) 
            {
              this.onSetupCompleted(this.newSetupId);
            }
            else 
            {
              this.setInfoAlert("Debes completar todos los campos para continuar.")
            }

          }
          else if (AppClientContext.Instance.setup.prevPrescription && this.isCaseFileCompleted) 
          {
            this.onSetupCompleted(this.newSetupId);
          }
          else 
          {
            this.setInfoAlert("Primero es necesario completar la información del setup");
          }
        });
    }
  }

  // Create new Stage
  private onCreateStage(setupId: number = 0): void
  {
    let lastStage;

    if(this.currentStages.length!=0)
    {
      lastStage = this.currentStages.filter(x=> x.isDeleted == false).pop();
    }

    let newStage: ICaseStage = {
      caseId: this.caseId,
      frecuencyDays: 0,
      comments: `Se ha creado la etapa ${lastStage ? lastStage.stageNumber+1 : 1}`,
      isManufactured: false,
      stageNumber: lastStage ? lastStage.stageNumber+1 : 1,
      setupId: setupId ? setupId : lastStage.setupId,
      statusId: StatusesID.InProcessOfDischarge,
      upperAligners: 0,
      lowerAligners: 0,
      updateStageReceivedDateRequired: true,
      createdFromCaseDetail: true,
      preSetupUsed: this.preSetupUsed,
      generalComments: this.generalComments,
      importantChangesComments: this.importantChangesComments,
    };

    this.dataService.insert(newStage, this.getQueryDefEcommerceConfig())
      .subscribe((response:any) =>
      {
        this.newCaseStage= response;
        this.caseStageSelected =this.newCaseStage;
        this.getAllCaseStages();
        if(this.setupType == 2)
        {
          let lastCaseStageSetup ={
            id: lastStage.setup.id,
            prescriptionId: lastStage.setup.prescriptionId,
            caseFileId: lastStage.setup.caseFileId,
            currentStep: lastStage.setup.currentStep,
            prevPrescription: lastStage.setup.prevPrescription
          }
          AppClientContext.Instance.initializeSetup(lastCaseStageSetup)
          this.onSetupCompleted();
        }
        this.generalComments = null;
        this.importantChangesComments = null;
        this.preSetupUsed = false;
      }, fail =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  // Create new Stage
  private onSetupCompleted(setupId: number = 0): void
  {
    this.updateSetup();
  }

  private onCreatedNewStage(): void
  {
    this.isPrescriptionCompleted = false;
    this.isCaseFileCompleted = false;
    this.chooseSetupTypeDialog.show = false;
    this.setupType = 0;
    this.createdNewStage = true;
    this.isPartialSave = false;
    this.formStep9Valid = false;
    AppClientContext.Instance.setup = null;

    this.sendMoveToStageReceivedStatusEmail(this.caseId, this.caseStageSelected.id);
    this.getAllCaseStages();
    this.onHandleClickEdit(this.newCaseStage);
    BroadcastManager.Instance.broadcast(AppEventNames.onUpdateProtocolForUseAligners, this.protocolForUseAlignersData);
    BroadcastManager.Instance.broadcast(AppEventNames.onUpdatePrescriptionFiles, true);
  }

  public onHandleClickAdd(): void
  {
    if (this.isFinalStatus)
    {
      this.currentNewStageId = this.currentStages[this.currentStages.length - 1].stageNumber;
      this.chooseSetupTypeDialog.show = true;
    }
    else
    {
      this.setInfoAlert("El caso no tiene un estatus final, no pueden crear más etapas.");
    }

  }

  sendMoveToStageReceivedStatusEmail(caseId:number, caseStageId:number):void {
    this.dataService.sendMoveToStageReceivedStatusEmail({caseId : caseId, caseStageId: caseStageId}).subscribe(res => {
      this.setSuccessAlert("El email de caso recibido se ha enviado correctamente..");
    }, err=>{
      this.setDangerAlert("El email de caso recibido no fue enviado, por favor intentalo de nuevo.");
    })
  }

  public onHandleShowShippingInfo(item:any){
    this.caseStageSelected = item;
    this.showShippingInfoDialog.show = true;
  }

  public onHandleReviewStage(caseStage: any): void
  {
    let queryDef = new UrlQueryDef();
    queryDef.includes = 'Product';
    this.stageToApprove = caseStage;
    this.disableAcceptSetup = false;
    this.hasSetupMechanics = false;
    this.isApproveChecked = false;
    if (this.stageToApprove.setupMechanics != "Sin mecánicas de setup") 
    {
      this.disableAcceptSetup = true;
      this.hasSetupMechanics = true;
    }
    this.caseDataService.getById(this.caseId, queryDef).subscribe((response) => {
      this.case=response;
      this.statusManagerService.setCurrentCase(this.case);
      this.getRemainingAligners(false);
    });
    this.approvalDialog.show = true;
  }

  public onAcceptSetup(): void
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {};
    queryDef.params['caseId'] = this.caseId;
    queryDef.params['setUpAcceptedAction'] = true;
    this.caseDataService.getUsedAlignersByCase(queryDef)
      .subscribe(res =>
      {
        this.statusManagerService.setCurrentCaseStage(this.stageToApprove);
        let totalAligners =  this.stageToApprove.upperAligners + this.stageToApprove.lowerAligners;

        if (this.case.productId != null && (this.case.productHasUnlimtedAligners || totalAligners <= this.remainingAligners)) 
        {
         this.onUpdateStatus(true, res.usedUpperAligners, res.usedLowerAligners);
        }
        else
        {
         this.setInfoAlert("No cuentas con alineadores suficientes adquiridos");
        }
      
    })  
  }

  public onUpdateStatus(isNextStatus: boolean, usedUpperAligners: number, usedLowerAligners: number): void
  {
    // Change order status
    let order = isNextStatus ? this.currentStatus.order+1 : this.currentStatus.order-1;
    // Get next or previous status
    let status = this.statusManagerService.getStatusInfo().find(x => x.order == order);

    if(isNextStatus)
    {
      let [canGoNextStatus, message] = this.statusManagerService.validateNextStatus();

      if(!canGoNextStatus)
      {
        this.setInfoAlert(message);
        this.approvalDialog.show = false;
        return;
      }
    }

    let body =
    {
      id: this.stageToApprove.id,
      caseId: this.caseId,
      statusId: status.id,
      stageNumber: this.stageToApprove.stageNumber,
      comments: `Cambio de estatus a ${status.name}, en la etapa ${this.stageToApprove.stageNumber}`
    };

    this.dataService.updateStatus(body)
      .subscribe(response =>
      {
        this.onUpdateCaseStageShipppingAddress(this.stageToApprove.id);
        this.setSuccessAlert("Estatus actualizado con éxito.");
        this.approvalDialog.show = false;
        this.getAllCaseStages();
        BroadcastManager.Instance.broadcast(AppEventNames.onUseNewAligners, usedUpperAligners, usedLowerAligners);
      }, (fail) =>{

      });
  }

  public onRefuseSetup(): void
  {
    this.isShowApprovalMessage = true;
  }

  public onUpdateAligners(): void
  {
    let aligners=this.alignersForm.value;
    this.alignersFormValue = aligners;
    let totalAligners=aligners.upperAligners + aligners.lowerAligners;
    if(totalAligners >= 16)
    {
      if (this.alignersForm.valid && (this.case.productHasUnlimtedAligners || totalAligners <= this.remainingAligners))
      {
        if ((aligners.upperAligners <= this.remainingCaseUpperAligners) && (aligners.lowerAligners <= this.remainingCaseLowerAligners)) 
        {
          this.goToShippingAddressSelection(true);
        }
        else
        {
          this.setInfoAlert("No cuentas con alineadores suficientes en el caso. " + "Restan " + this.remainingCaseUpperAligners + " alineadores superiores y " + this.remainingCaseLowerAligners + " alineadores inferiores" + " por fabricar.");
        }

      }
      else
      {
        this.setInfoAlert("No cuentas con alineadores suficientes adquiridos. " + "Tienes " + this.remainingAligners + " disponibles.");
      }
    }
    else 
    {
      //extra validations with product with less than 16 aligners
      if (this.case.productAlignersQuantity >= 16) {
        if ((this.remainingCaseLowerAligners + this.remainingCaseUpperAligners) >= 16) {
          this.setDangerAlert("La cantidad mínima de alineadores por etapa es de 16, ingrese una cantidad mayor.");
        }
        else {
          //guardar
        }
      }
      else
      {
        if ((aligners.upperAligners + aligners.lowerAligners) > this.remainingAligners) {
          this.setInfoAlert("No cuentas con alineadores suficientes adquiridos. " + "Tienes " + this.remainingAligners + " alineadores disponibles.");
        }
        else if ((aligners.upperAligners + aligners.lowerAligners) < this.case.productAlignersQuantity && this.remainingAligners > 0) {
          this.setInfoAlert("No es posible fabricar una cantidad de alineadores menor a la disponible en el paquete contratado. " + "Tienes " + this.case.productAlignersQuantity + " alineadores disponibles.");
        }
        else if ((aligners.upperAligners + aligners.lowerAligners) == this.case.productAlignersQuantity && this.remainingAligners > 0)
        {
          this.goToShippingAddressSelection(true);
        }
        else{
          this.setDangerAlert("La cantidad mínima de alineadores por etapa es de 16, ingrese una cantidad mayor.");
        }

      }
    }

  }

  public getRemainingAligners(setUpAcceptedAction:boolean)
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {};
    queryDef.params['caseId'] = this.caseId;
    queryDef.params['setUpAcceptedAction'] = setUpAcceptedAction;
    let queryDef2 = new UrlQueryDef();
    queryDef2.includes = 'Product';
    this.caseDataService.getById(this.caseId, queryDef2).subscribe((result) => {
      this.case = result;
      this.caseDataService.getUsedAlignersByCase(queryDef).subscribe(res => {
        this.statusManagerService.setCurrentCaseStage(this.stageToApprove);
        this.remainingAligners = this.case.totalAligners - (res.usedUpperAligners + res.usedLowerAligners);
        this.remainingCaseUpperAligners = res.remainingUpperAligners;
        this.remainingCaseLowerAligners = res.remainingLowerAligners;
        this.fabricatedLowerAligners=res.usedLowerAligners;
        this.fabricatedUpperAligners=res.usedUpperAligners;
        if (this.remainingCaseLowerAligners + this.remainingCaseUpperAligners < 16) {
          this.disableEditAligners = true;
          this.lastStage = true;
        }
      }); 
    })
 
  }

  public onHandleClickEdit(item: any): void
  {
    this.currentLowerAligners = item.lowerAligners;
    this.currentUpperAligners = item.upperAligners;
    this.currentFrequency = item.frecuencyDays;
    this.currentStartDate = item.startDate;

    this.caseDataService.getById(this.caseId).subscribe((response) => {
      this.case = response;
      this.statusManagerService.setCurrentCase(this.case);
      this.getRemainingAligners(false);
    });
    if(!item.statusIsCancelable)
    {
      item.editMode = !item.editMode;
      if(!item.editMode)
      {
        this.loading = true;
        if((item.upperAligners + item.lowerAligners) >= 16)
        {
          if(this.case.productHasUnlimtedAligners || ((item.upperAligners + item.lowerAligners) <= this.remainingAligners))
          {
            if ((item.upperAligners <= this.remainingCaseUpperAligners) && (item.lowerAligners <= this.remainingCaseLowerAligners)) 
            {
              this.updateAlignersQuantity(item);
            }
            else
            {
              item.editMode = !item.editMode;
              this.setDangerAlert("No cuentas con alineadores suficientes en el caso. " + "Restan " + this.remainingCaseUpperAligners + " alineadores superiores y " + this.remainingCaseLowerAligners+ " alineadores inferiores"+" por fabricar.");
            }
          }
          else
          {
            item.editMode = !item.editMode;
            this.setDangerAlert("No cuentas con alineadores suficientes adquiridos. " + "Tienes " + this.remainingAligners + " disponibles.");
          }
        }
        else
        {
          if (this.case.productAlignersQuantity >= 16) {
            if ((this.remainingCaseLowerAligners + this.remainingCaseUpperAligners) >= 16) {
              item.editMode = !item.editMode;
              this.setDangerAlert("La cantidad mínima de alineadores por etapa es de 16, ingrese una cantidad mayor.");
            }
          }
          else
          {
            if ((item.upperAligners + item.lowerAligners) > this.remainingAligners)
            {
              item.editMode = !item.editMode;
              this.setInfoAlert("No cuentas con alineadores suficientes adquiridos. " + "Tienes " + this.remainingAligners + " alineadores disponibles.");
            }
            else if ((item.upperAligners + item.lowerAligners) < this.case.productAlignersQuantity) {
              item.editMode = !item.editMode;
              this.setInfoAlert("No es posible fabricar una cantidad de alineadores menor a la disponible en el paquete contratado. " + "Tienes " + this.case.productAlignersQuantity + " alineadores disponibles.");
            }
            else if ((item.upperAligners + item.lowerAligners) == this.case.productAlignersQuantity)
            {
              this.updateAlignersQuantity(item);
            }

          }
          
        }
        

      }
    }
    else{
      this.setDangerAlert("No se puede editar una etapa en estatus cancelable");
    }

  }

  public updateAlignersQuantity(item: any)
  {
    this.dataService.update(item, this.getQueryDefEcommerceConfig())
      .subscribe(response => {
        this.loading = false;
        this.getAllCaseStages();
        this.setSuccessAlert('Etapa actualizada correctamente');
      }, fail => {
        this.setWarningAlert(fail.error.message);
      });
  }

  public onHandleClickDelete(item: any): void
  {
    if (item.statusIsCancelable)
    {
      //The user is allowed to delete
      this.deleteDialog.show = true;
      this.caseStageSelected = item;
    }
    else
    {
      //The user is not allowed to delete
      this.setInfoAlert("El estatus de la etapa no permite que sea cancelada");
    }

  }

  public onHandleClickClose(item:any)
  {
    this.getAllCaseStages();
  }

  public onDeleteEntity(): void
  {
    this.dataService.delete(this.caseStageSelected.id, this.getQueryDefEcommerceConfig())
      .subscribe(response =>
      {
        this.setSuccessAlert('Etapa cancelada satisfactoriamente');
        this.getAllCaseStages();
        this.getById(this.id);
        this.isPartialSave = false;
        this.deleteDialog.show = false;
        BroadcastManager.Instance.broadcast(AppEventNames.onUpdatePrescriptionFiles, true);
      }, fail =>
      {
        this.setDangerAlert(fail.error);
      });
  }

  public onCancelChooseSetup(): void
  {
    this.setupType = 0;
  }

  public get currentStatus(): Status
  {
    return this.statusManagerService.currentStatus;
  }

  public get nextStatus(): Status
  {
    return this.statusManagerService.nextStatus;
  }

  public get beforeStatus(): Status
  {
    return this.statusManagerService.beforeStatus;
  }

  public isInFabricationProcess(orderStatus: number): boolean
  {
    return orderStatus>=this.orderStatusToValidateAligners;
  }

  public isPendingToApprove(element: any): boolean
  {
    return element.orderStatus==this.orderStatusToValidateAligners && !element.isPendingToReviewAlignersQuantity;
  }

  public canDragElement(element: any): boolean
  {
    return element.stageNumber==1 || element.statusId>=9;
  }



  // ********************************************************************************
  // #region Method Overrides
  // ********************************************************************************
  public onGetQueryDefForGetLastCaseStageCreated()
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {};
    queryDef.params['caseId'] = this.caseId;

    return queryDef;
  }
  
  public onGetQueryDefForGetAll()
  {
    let queryDef = new UrlQueryDef();
    queryDef.includeDeletedRows = true;
    queryDef.filter = 'CaseId eq ' + this.caseId;
    queryDef.orderby = 'StageNumber';
    //queryDef.includes = "Setup,Setup.CaseFile"
    queryDef.includes = "Setup,Setup.CaseFile,Setup.DentalMonitoringSmartStl"
    return queryDef;
  }

  public onCheckboxChange(event: any): void
  {
    if (event == true) {
      this.disableAcceptSetup = false;
    }
    else {
      this.disableAcceptSetup = true;
    }
  }

  public get caseStagesSelected(): any[]
  {
    return this.currentStages.filter(x => x.checked == true && x.isDeleted == false ).map((x) =>
    {
      let newObj = {stageNumber: x.stageNumber, alignersQuantity: x.alignersQuantity };
      return newObj;
    });
  }

  private getQueryDefEcommerceConfig(): any
  {
    return new UrlQueryDef().getRequestConfig(true);
  }

  /*
 * Methods used to detect the screen resolution */
  @HostListener('window:resize', ['$event'])
  onResize(event)
  {
    this.checkResolution();
  }
  private checkResolution(): void
  {
    if (window.innerWidth < 930)
    {
      this.size930 = true;
    }
    else
    {
      this.size930 = false;
    }
  }

  public downloadPrescription(url: string)
  {
    const link = this.renderer.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', url);
    link.setAttribute('download', `Prescripción.pdf`);
    link.click();
    link.remove();
  }

  private updateSetupProtocolForUseAligners(): void
  {
    this.caseDataService.updateProtocolForUseAligners(this.protocolForUseAlignersData)
      .subscribe(response =>
      {
        this.setSuccessAlert("¡Setup terminado con éxito!");
        BroadcastManager.Instance.broadcast(AppEventNames.onGeneratePrescriptionDocument, true);
        this.createdNewStage = false;
      }, fail =>
      {
        this.setWarningAlert(fail.error.errorDetail.message);
      });
  }

  public goToSetupLink(element) : void
  {
    if(element.setupLink.includes('http')||element.setupLink.includes('https'))
    {
      window.open(element.setupLink, '_blank','noreferrer');
      
    }
    else{
      window.open('http://'+element.setupLink, '_blank','noreferrer');
    }
  }

  public goToSetupLinkPx(element) : void
  {
    if(element.setupLinkPx.includes('http')||element.setupLinkPx.includes('https'))
    {
      window.open(element.setupLinkPx, '_blank','noreferrer');
      
    }
    else{
      window.open('http://'+element.setupLinkPx, '_blank','noreferrer');
    }
  }

  public goToCaseSetupFiles(element){
    const url = this.router.createUrlTree([`ecommerce/mis-casos/archivos-de-caso/${element.caseId}/stage/${element.stageNumber}`])
    window.open(url.toString(), '_blank')
  }

  public getAllStatus(): void
  {
    let queryDef = new UrlQueryDef();
    this.statusDataService.get(queryDef)
    .subscribe((response: any) =>
    {
      this.statusList = response.rows;
     
    }, (fail: any) =>
    {
      this.setWarningAlert(fail.error.message);
    });
  }

  public onCancelStage(item: any): void
  {
    this.deleteStageDialog.show = true;
  }

  public onDeleteCaseStage(): void
  {
    
    this.dataService.delete(this.stageToApprove.id, this.getQueryDefEcommerceConfig())
      .subscribe(response =>
      {
        if(this.stageToApprove.stageNumber==1)
        {
          this.setSuccessAlert('Etapa y caso eliminados satisfactoriamente');
          this.router.navigate(["/ecommerce/mis-casos"])
        }
        else
        {
          this.setSuccessAlert('Etapa cancelada satisfactoriamente');
          this.deleteStageDialog.show = false;
          this.approvalDialog.show = false;
          this.getAllCaseStages();
        }
        
        //checar si se eliminó el caso

      }, fail =>
      {
        this.setDangerAlert(fail.error);
      });
  }
  public setupInUse() : boolean
  {
    let currentSetup= this.currentStages.find(x => x.stageNumber == this.stageToApprove.stageNumber);
    let currentSetupStages:any [] = this.currentStages.filter(x => x.setupId == currentSetup.setupId && x.isDeleted == false );
    return currentSetupStages.length > 1 ? true : false;
  }

  public onSuggestAlignersByAliwell(): void
  {
    if (!this.setupInUse())
    {
      this.suggestAlignersByAliwellDialog.show = true;
    }
    else
    {
      this.setInfoAlert("No se pueden realizar cambios a un setup previamente utilizado.");
    }
    
  }

  public onAddComments(): void 
  {
    let correctionOptionsLabel = this.setupCorrectionsOptions.find(x => x.value == this.selectedSetupCorrection).label;
    let comments = (this.correctionValues[0] != "" ? this.correctionValues[0]  : this.correctionValues[1]  != "" ? this.correctionValues[1] : this.correctionValues[2]);
    if (comments) {
      let body =
      {
        id: this.stageToApprove.id,
        caseId: this.caseId,
        statusId: StatusesID.SetupChanges,
        stageNumber: this.stageToApprove.stageNumber,
        commentsBackoffice: "Cantidad previa de alineadores totales requeridos. Superiores: " + this.case.upperAligners + " Inferiores: " + this.case.lowerAligners + ". " + correctionOptionsLabel + ". Comentarios: " + comments,
        commentsEcommerce: "Cantidad previa de alineadores totales requeridos. Superiores: " + this.case.upperAligners + " Inferiores: " + this.case.lowerAligners + ". " + correctionOptionsLabel +  ". Comentarios: " + comments,
        changeType: this.selectedSetupCorrection,
        setupChangesComments: "Cantidad previa de alineadores totales requeridos. Superiores: " + this.case.upperAligners + " Inferiores: " + this.case.lowerAligners + ". " + correctionOptionsLabel +  ". Comentarios: " + comments,
        isRequestChangeSetup: true
      };
      this.dataService.updateStatus(body)
        .subscribe(() => {
          this.suggestAlignersByAliwellDialog.show = false;
          this.approvalDialog.show = false;
          this.setInfoAlert("Se cambió a estatus Cambios de setup y los comentarios fueron enviados correctamente.");
          this.getAllCaseStages();
        });
    }
    else {
      this.setInfoAlert("Es necesario ingresar los detalles de la opción seleccionada para continuar");
    }

  }

  public completeCaseStage(item: any)
  {
    this.caseStageSelected = item ;
    this.setupType = 1;

    AppClientContext.Instance.initializeSetup(
      {
        id: item.setup.id,
        prescriptionId: item.setup.prescriptionId,
        caseFileId: item.setup.caseFileId,
        currentStep: item.setup.currentStep,
        prevPrescription: item.setup.prevPrescription
      }
    );
    this.getSetupInfoToValidate(true); 
  }

  public updateSetup()
  {
    let body = 
    {
      id: AppClientContext.Instance.setup.id,
      prescriptionId: AppClientContext.Instance.setup.prescriptionId,
      caseFileId: AppClientContext.Instance.setup.caseFileId,
      isPartialSave: !this.isPrescriptionCompleted
    }
    this.setupDataService.updateSetupById(body)
    .subscribe((res)=>
    {
      if(this.isCaseFileCompleted && this.isPrescriptionCompleted){
        this.updateCaseStage();
        this.isPrescriptionCompleted = false;
        this.isCaseFileCompleted = false;
      }else{
        this.formStep9Valid = false;
        this.getSetupInfoToValidate();
      }

      this.chooseSetupTypeDialog.show = false;
      BroadcastManager.Instance.broadcast("uncheck-confirmation",false);
      this.getAllCaseStages();
    });
  }

  public updateCaseStage()
  {
    let body =
    {
      id: this.caseStageSelected.id,
      caseId: this.caseStageSelected.caseId,
      statusId: StatusesID.StageReceived,
      stageNumber: this.caseStageSelected.stageNumber,
      commentsBackoffice: "",
      commentsEcommerce: "",
      updateStageReceivedDateRequired: true,
    };
    this.dataService.updateStatus(body)
      .subscribe(() =>
      {
        this.onCreatedNewStage();
      });
  }

  public onCheckboxAcceptChange(e:any)
  {
    if(e == true)
    {
      this.disableAcceptSetup = false;
    }
    else{
      this.disableAcceptSetup = true;
    }
  }

  public onReactivateCaseStage(caseStageId: number) : void
  {
    let body ={
      caseStageId: caseStageId
    }
    this.dataService.reactivateCaseStage(body)
    .subscribe(()=>{
      this.setInfoAlert("Se reactivó la etapa exitosamente");
      //BroadcastManager.Instance.broadcast("on-reactivate-case-stage");
      this.getAllCaseStages();
    })
  }

  checkCommentsEmptyOrNull(comment:any){
    if(comment == null || comment == ''){
      return 'No hay comentarios.'
    }else{
      return comment;
    }
  }

  public updateCaseStageAligners()
  {
    let body = this.alignersFormValue;
    body['id'] = this.stageToApprove.id;
    body['IsPendingToReviewAlignersQuantity'] = false;
    
    this.dataService.updateAligners(body)
      .subscribe(response => {
        this.setSuccessAlert("Información enviada correctamente");
        this.isShowApprovalMessage = false;
        this.approvalDialog.show = false;
        this.stageToApprove.caseStageUpperAligners = this.alignersFormValue.upperAligners;
        this.stageToApprove.caseStageLowerAligners = this.alignersFormValue.lowerAligners;
        // this.statusManagerService.setCurrentCaseStage(this.stageToApprove);
        this.isApproveWithChanges = false;
        this.onAcceptSetup();
        this.getById(this.id);
      }, (fail => {
        this.setDangerAlert(fail.error.message);
      }));
  }

  public getMaxHoursToSetAddress()
  {
    let queryDef = new UrlQueryDef();
    queryDef.params = {
      key : 'MaxHoursToSetAddress'
    };
    this.systemConfigDataService.getSystemConfigValueByKey(queryDef)
    .subscribe((res)=>{
      this.maxHoursToUpdateDate = res.value;
    })
  }

  public getAddresses() : void
  {
    var queryDef = new UrlQueryDef();
    this.customerAddressDataService.getCustomerAddressByCustomerId(this.customerId)
    .subscribe((res)=>{
      this.customerAddresses = res;
      this.addressExceptionsDataService.getAddressExceptions(queryDef)
      .subscribe((res2)=>{
        this.exceptionAddresses = res2;
        this.exceptionAddresses = this.exceptionAddresses.map(x=>  ({
          ...x,           // Spread the existing properties
          isAddressException : true
        })
           );
        this.addressList = this.customerAddresses.concat(this.exceptionAddresses);
        this.defaultAddress = this.addressList.find(x=> x.isDefault == true);
        this.selectedAddress = this.defaultAddress;
        this.getMaxHoursToSetAddress();
      });

    })
  }

  public goToShippingAddressSelection(isApproveWithChanges: boolean)
  {
    this.isApproveWithChanges = isApproveWithChanges;
    this.shippingAddressSelectionProcess = 2;
  }

  public onShippingAddressChange()
  {
    this.previousAddress = this.selectedAddress;
    this.shippingAddressSelectionProcess = 3;
  }

  public onGoToCustomerProfileConfirmation()
  {
    this.shippingAddressSelectionProcess = 4;
  }

  public onGoToCustomerProfile()
  {
    this.router.navigate(['/ecommerce/mi-perfil']);
  }

  public onCancelAddressAssign()
  {
    this.updateAlignersValidationsPassed = false;
    this.selectedAddress = this.defaultAddress;
    this.shippingAddressSelectionProcess = 1;
    if (this.stageToApprove.setupMechanics != "Sin mecánicas de setup") 
    {
      this.disableAcceptSetup = true;
      this.hasSetupMechanics = true;
    }
    this.isApproveChecked = false;
  }

  public onCancelAddressSelection2()
  {
    this.selectedAddress = this.previousAddress;
    this.shippingAddressSelectionProcess = 2;
  }

  public onUpdateCaseStageShipppingAddress(caseStageId:any)
  {
    let body =
    {
      id: caseStageId,
      addressId: this.selectedAddress.id,
      isAddressException: this.selectedAddress.isAddressException ? true : false,
      customerId: this.customerId
    };
    this.dataService.updateCaseStageCustomerAddress(body)
    .subscribe((res)=>
    {
      this.updateCaseStageAddressDialog.show = false;
      this.setInfoAlert("Dirección asignada a etapa correctamente");
      this.getAllCaseStages();
    });
  }

  public onConfirmSetup()
  {
    if(this.isApproveWithChanges)
    {
      this.updateCaseStageAligners();
    }
    else
    {
      this.onAcceptSetup();
    }
  }

  public onEditCaseStageShippingAddress(caseStage:any)
  {
    const nowUTC = new Date().toISOString();
    if(caseStage.shippmentAddressChangeExpirationDate > nowUTC )
    {
      this.caseStageAddressToUpdate = caseStage;
      this.shippingAddressSelectionProcess = 2;
      if (caseStage.shipmentCustomerAddress != null || caseStage.shipmentExceptionAddress != null) 
      {
        this.selectedAddress = this.addressList.find(x => x.fullAddress == caseStage.shipmentCustomerAddress || x.fullAddress == caseStage.shipmentExceptionAddress);
      }
      else 
      {
        this.selectedAddress = this.addressList.find(x => x.isDefault == true);
      }
      this.updateCaseStageAddressDialog.show = true;
    }
    else
    {
      this.setInfoAlert("El tiempo límite de edición de la fecha ha terminado.");
    }

  }

  onSelectionChange(event: MatRadioChange) {
    this.previousAddress = this.selectedAddress;
    this.selectedAddress = event.value;
  }

  public onUpdateShippingAddress()
  {
    this.onUpdateCaseStageShipppingAddress(this.caseStageAddressToUpdate.id);
  }

  public onCancelAddressSelectionUpdate()
  {
    this.updateCaseStageAddressDialog.show = false;
  }

  public onCancelAddressEdition()
  {
    this.shippingAddressSelectionProcess = 3;
  }

  public onBackToMainPage()
  {
    this.isShowApprovalMessage = false 
    if (this.stageToApprove.setupMechanics != "Sin mecánicas de setup") 
      {
        this.disableAcceptSetup = true;
        this.hasSetupMechanics = true;
      }
      this.isApproveChecked = false;
  }

  public onSetupCorrectionSelectionChange()
  {
    this.correctionValues = Array(this.setupCorrectionsOptions.length).fill('');
  }

  getSetupInfoToValidate(completeCaseStage: boolean = false){
    let queryDef = new UrlQueryDef;
    queryDef.includes = "DentalMonitoringSmartStl,CaseFile";
    this.setupDataService.getById(AppClientContext.Instance.setup.id, queryDef).subscribe((res:any)=>{
      if(res.usesSmartStl == true && res.dentalMonitoringSmartStlId != null && res.dentalMonitoringSmartStl?.status == SmartSTLRequestStatuses.get("Smart STL disponible")
      && res.caseFileId != null && res.caseFile.upperSTLId != null && res.caseFile.lowerSTLId != null){
        this.isCaseFileCompleted = true;
      }else if(res.usesSmartStl == false && res.caseFileId != null && res.caseFile.lowerSTLId != null && res.caseFile.upperSTLId != null){
        this.isCaseFileCompleted = true;
      }else{
        this.isCaseFileCompleted = false;
      }

      this.isPartialSave = res.isPartialSave;

      if(!AppClientContext.Instance.setup.prevPrescription)
      {
        this.isPrescriptionCompleted = !res.isPartialSave;
      }
      else
      {
        this.isPrescriptionCompleted = true;
      }
      
      this.setupValidationsDone = true;
      if(completeCaseStage){
        this.chooseSetupTypeDialog.show = true;
        BroadcastManager.Instance.broadcast("on-complete-case-stage",true);
        BroadcastManager.Instance.broadcast("on-intialize-stepper-to-complete",true);
        BroadcastManager.Instance.broadcast("on-load-setup",true);
      }
    })    
  }

  checkCaseStageComplete(caseStage: any){
    let validate = false;
    if(!caseStage.setup.isPartialSave 
      && caseStage.statusId != StatusesID.StageCancelled 
      && caseStage.setup.usesSmartStl == true 
      && caseStage.setup.dentalMonitoringSmartStlId != null 
      && caseStage.setup.dentalMonitoringSmartStl?.status == SmartSTLRequestStatuses.get("Smart STL disponible")
      && caseStage.setup.caseFileId != null 
      && caseStage.setup.caseFile.upperSTLId != null 
      && caseStage.setup.caseFile.lowerSTLId != null){
      validate = true;
    }else if(!caseStage.setup.isPartialSave 
      && caseStage.statusId != StatusesID.StageCancelled 
      && caseStage.setup.usesSmartStl == false 
      && caseStage.setup.caseFileId != null 
      && caseStage.setup.caseFile.lowerSTLId != null && caseStage.setup.caseFile.upperSTLId != null){
      validate = true;
    }else if(caseStage.statusId == StatusesID.StageCancelled){
      validate = true;
    }
    return validate;
  }
}
